export default "__VITE_ASSET__CD$Y7Q1f__"